import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  dropdown: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0',

    '& > :first-child': {
      marginRight: '0.5rem'
    },

    '& .menu': {
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${theme.border.outline}`,
      borderRadius: '5px',
      boxSizing: 'border-box',
      padding: '0.25rem',

      '& > :first-child': {
        color: theme.palette.textAlt,
        marginRight: '1rem'
      }
    }
  },

  title: {
    fontSize: theme.size.sm
  },

  fieldValue: {
    color: '#323436'
  },

  type: {
    fontSize: theme.size.sm
  }
}))

export default useStyles
